import { Dialog } from "@dash/dialog";
import { useDeviceType } from "@dash/mq";
import { SearchButton } from "@dash/search";
import { useTheme } from "@emotion/react";
import { useMemo, useState } from "react";
import type { FC } from "react";

import { getSelectedReasonSummary } from "./supportTicketReasonCategories";
import { SupportTicketReasonPickerContent } from "./SupportTicketReasonPickerContent";

type Props = {
  selectedReasonIds: string[];
  onSelectedReasonIdsChange: (selectedReasonIds: string[]) => void;
};

export const SupportTicketReasonPicker: FC<Props> = ({ selectedReasonIds, onSelectedReasonIdsChange }) => {
  const theme = useTheme();
  const { isMobile } = useDeviceType();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const selectedSummary = useMemo(() => getSelectedReasonSummary(selectedReasonIds), [selectedReasonIds]);

  return (
    <div css={{ display: "flex", flexDirection: "column", gap: "0.25rem" }}>
      <label
        css={{
          color: theme.colors.primary,
          fontSize: "0.875rem",
          fontFamily: theme.displayFontFamily,
        }}
      >
        Przedmiot zgłoszenia
      </label>
      <SearchButton
        variant="primary"
        onClick={() => setIsDialogOpen(true)}
        inputText={selectedSummary || "Wybierz przedmiot zgłoszenia..."}
        css={{
          "button > div > div": {
            minHeight: "46px",
            display: "flex",
            alignItems: "center",
            paddingTop: "0.5rem",
            paddingBottom: "0.5rem",
            color: selectedSummary ? theme.colors.primary : theme.colors.secondaryText,
          },
        }}
      />
      {isDialogOpen ? (
        <Dialog
          header="Przedmiot zgłoszenia"
          placement={isMobile ? "bottom" : "center"}
          onClose={() => setIsDialogOpen(false)}
          css={{ width: isMobile ? "100%" : "min(520px, calc(100vw - 2rem))" }}
        >
          <SupportTicketReasonPickerContent
            selectedReasonIds={selectedReasonIds}
            onSelectedReasonIdsChange={onSelectedReasonIdsChange}
          />
        </Dialog>
      ) : null}
    </div>
  );
};
